import useScreenSize from "../../../hoc/useScreenSize";
import Slider from "../carousel/Slider";
import PAText from "../typography/PAText/PAText";
import styles from "./category-section.module.scss";
import CategorySlectionCardBig from "./CategorySlectionCardBig";

function CarouselCategorySection(props: any) {
  const { categoryUrls, title } = props;
  const [isMobile, , isDesktop] = useScreenSize();

  if (!categoryUrls?.length) {
    return null;
  }

  const showArrow = (isDesktop && categoryUrls.length > 3) || (isMobile && categoryUrls.length > 1);

  return (
    <div className={styles.carousel_category_section}>

      <PAText
        component="h2"
        className="product_common_title"
        inlineBlock
        bold
      >
        {title}
      </PAText>

      <div>

        <Slider hideArrow={!showArrow} tileWidth={250} itemStyle={{ maxWidth: 250, minWidth: 250 }}>
          {categoryUrls.map((categoryUrl: any) => {
            const { url, linkDetails } = categoryUrl;
            return (
              <CategorySlectionCardBig key={url} {...{ linkDetails, url }} />
            );
          })}
        </Slider>
      </div>
    </div>
  );
}

export default CarouselCategorySection;
